import { defineMessages } from 'react-intl';

const messages = defineMessages({
  background: { id: 'Background', defaultMessage: 'Background' },
  white: { id: 'White', defaultMessage: 'White' },
  grey: { id: 'Light grey', defaultMessage: 'Light grey' },
  blue: { id: 'Blue', defaultMessage: 'Blue' },
  alignment: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },
  left: {
    id: 'Left',
    defaultMessage: 'Left',
  },
  center: {
    id: 'Center',
    defaultMessage: 'Center',
  },
  sectionBlock: {
    id: 'Section',
    defaultMessage: 'Section',
  },
  fieldsetDefaultTitle: {
    id: 'fieldsetDefaultTitle',
    defaultMessage: 'Default',
  },
  titlePropertyTitle: {
    id: 'titlePropertyTitle',
    defaultMessage: 'Title',
  },
  titlePropertyDescription: {
    id: 'titlePropertyDescription',
    defaultMessage: 'Section friendly name',
  },
  asPropertyTitle: {
    id: 'asPropertyTitle',
    defaultMessage: 'HTML5 element',
  },
  asPropertyDescription: {
    id: 'asPropertyDescription',
    defaultMessage: 'Select HTML5 element to be used for this block',
  },
});

const Schema = (intl) => ({
  title: intl.formatMessage(messages.sectionBlock),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.fieldsetDefaultTitle),
      fields: ['alignment', 'background'],
    },
  ],
  properties: {
    background: {
      title: intl.formatMessage(messages.background),
      type: 'string',
      choices: [
        ['none', intl.formatMessage(messages.white)],
        ['muted', intl.formatMessage(messages.grey)],
        ['primary', intl.formatMessage(messages.blue)],
      ],
      default: 'none',
      noValueOption: false,
      isClearable: false,
    },
    alignment: {
      title: intl.formatMessage(messages.alignment),
      type: 'string',
      choices: [
        ['left', intl.formatMessage(messages.left)],
        ['center', intl.formatMessage(messages.center)],
      ],
      default: 'left',
      noValueOption: false,
      isClearable: false,
    },
    title: {
      title: intl.formatMessage(messages.titlePropertyTitle),
      description: intl.formatMessage(messages.titlePropertyDescription),
      type: 'string',
    },
    as: {
      title: intl.formatMessage(messages.asPropertyTitle),
      description: intl.formatMessage(messages.asPropertyDescription),
      type: 'string',
      factory: 'Choice',
      default: 'div',
      choices: [
        ['div', 'div'],
        ['section', 'section'],
        ['article', 'article'],
        ['aside', 'aside'],
        ['details', 'details'],
      ],
    },
  },
  required: [],
});

export default Schema;
